import { Container, Typography } from "@mui/material";
import { useTheme } from "../context/context";

export default function ContentLinks({link,icon,name}){
    const { fontSize } = useTheme();

    const containerStyle = {
      background: "white",
      padding: "5px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      maxWidth: "200px",
      textAlign: "center",
      textDecoration: "none",
      boxShadow:"0 0 2px 0px gray",
      height:"100%",
      minHeight:"150px",
      margin:"5px 0 5px 10px"
    };
  
    const typographyStyle = {
      fontSize: `${fontSize-0.1}rem`,
      textDecoration: "none",
      color: "black",
    };
    return(
        <Container style={containerStyle}>
          <a href={link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
        <img src={icon} alt="logo" height="100px" style={{maxWidth:"180px"}} />
        <Typography variant="h5" style={typographyStyle}>{name}</Typography>
        </a>
      </Container>
    )
}